/**
 * Priority codes for cases
 * Maps to backend sla_configurations.code values
 */
export enum PriorityCode {
  Critical = 'critical',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  StandardRequest = 'standard_request',
  ComplianceReview = 'compliance_review',
}
